import logo from "./../../images/logo.png";
import SignInForm from "./Components/SignInForm";
import SignInLeftSide from "./Components/SignInLeftSide";

const SignIn = () => {
  return (
    <div className="w-full grid grid-cols-4 gap-2 h-[100vh]">
      <img className=" absolute w-20 top-2 left-2" src={logo} />
      <SignInLeftSide />
      <div className="flex flex-col justify-center px-20 gap-4 xl:col-span-2 md:col-span-3">
        <h2 className="font-semibold tracking-widest px-1">
          Sign In Dashboard
          <SignInForm />
        </h2>
      </div>
    </div>
  );
};

export default SignIn;
